"use client";

import { createContext, useEffect, useContext, useState } from "react";

import { useRouter } from "next/navigation";

import { useAuth } from "@/store/AuthStoreProvider";
import { RootStore } from "@/store/RootStore";

export const RootStoreContext = createContext<RootStore | undefined>(undefined);

export function useStore(): RootStore {
  const context = useContext(RootStoreContext);
  if (context === undefined) {
    throw new Error("useStore must be used within RootStoreProvider");
  }

  return context;
}

export function RootStoreProvider({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  const router = useRouter();
  const [rootStore] = useState(() => new RootStore({ auth, router }));

  useEffect(() => {
    return () => {
      rootStore.dispose();
    };
  }, [rootStore]);

  useEffect(() => {
    if (rootStore) {
      rootStore.signInFlow.handleRedirectResult();
    }
  }, [rootStore]);

  return <RootStoreContext.Provider value={rootStore}>{children}</RootStoreContext.Provider>;
}
